import { DashboardRoutes } from "@/router/constant";
import { atom } from "jotai";

interface CoreAtom {
  lastVisitedUrlThatWasAPage?: string;
  upgradeUserPanel: {
    toPro: {
      service?: "invoice";
      showModal: boolean;
    };
    toStandard: {
      service?: "onlineShop";
      showModal: boolean;
    };
  };
  firstUrlToSettingsAndProfile: string;
}
export const coreAtom = atom<CoreAtom>({
  lastVisitedUrlThatWasAPage: undefined,
  upgradeUserPanel: {
    toPro: {
      service: undefined,
      showModal: false,
    },
    toStandard: {
      service: undefined,
      showModal: false,
    },
  },
  firstUrlToSettingsAndProfile: DashboardRoutes.home.overview.url,
});
